<template>
  <div class="search-list-bottom">
    <strong class="info-question">
      {{/*조회 내역이 더 이상 없습니다.*/$t("MINQ-02-01-04-10")}}
      <br />
      {{/*추가로 기간을 조회 하시겠습니까?*/$t("MINQ-02-01-04-11")}}
    </strong>
    <div class="inline-button-group">
      <template v-for="(data, i) in defaultRangeList">
        <button
          ref="rangeBtn"
          :class="['btn sm inline', i == defaultRangeIndex ? 'selected' : '']"
          :key="i"
          @click="changeRangeDate(data, i)"
        >{{ data.text == "MLON-01-02-01-11" ? $t("MLON-01-02-01-11", { 1: "1" }) : $t(data.text) }}</button>
      </template>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  props: {
    defaultRangeIndex: {
      type: Number,
    },
    gridUse: {
      type: Boolean,
      default: true,
    },
    page: {
      type: String,
    },
    defaultRangeList: {
      type: Array,
      required: false,
      default: () => [
        { text: "1M", value: -1 },
        { text: "3M", value: -3 },
        { text: "6M", value: -6 },
        { text: "MINQ-02-01-04-12", value: "" }, //검색 조건 변경
      ],
    },
  },
  data() {
    return {
      //rangeTextList: ["1M", "3M", "6M", "검색조건 변경"],
      parent: null,
      minStartDate: "",
      minEndDate: "",
    };
  },
  computed: {},
  created() {
    // this.$log.info(Vue.component("AccountSearchBox"))
    this.$log.info(this.$root);
  },
  async mounted() {
    const globalToday = await this.ACT_GET_SERVERINFO_ALL().then(data => this.moment(data.sysDateTime, "YYYYMMDD").format("YYYYMMDD"));
    let startDate = this.$getDateToString(this.moment().add(1, "d").format("YYYYMMDD"));

    this.minStartDate = this.$getDateToString(this.moment(startDate, "YYYYMMDD").add(-60, "M")._d);
    this.minEndDate = this.$getDateToString(this.moment(globalToday, "YYYYMMDD").add(-48, "M")._d);
  },
  methods: {
    ...mapActions(["ACT_SET_SERVERINFO_ALL", "ACT_GET_SERVERINFO_ALL"]),
    changeRangeDate(data, i) {
      this.$log.debug(i);
      for (const key of this.$refs.rangeBtn) {
        key.classList.remove("selected");
      }

      const searchBox = this.findSearchBox(this.$root.$children);

      if (this.gridUse) {
        if (data.value == "" || data.value == null) {
          searchBox.filterOpened = true;
        } else {
          searchBox.addDate(data.value, "addSearch");
        }
      } else {
        if (data.value == "" || data.value == null) {
          searchBox.filterOpened = true;
        } else {
          searchBox.addDate(data.value);
          if (this.page == "rpayRsultInq") {
            if (searchBox.param_.tranStartYmd < this.minStartDate) {
              this.$set(searchBox.param_, "tranEndYmd", this.minEndDate);
              this.$set(searchBox.srchParam, "tranEndYmd", this.minEndDate);
              this.$set(searchBox.param_, "tranStartYmd", this.minStartDate);
              this.$set(searchBox.srchParam, "tranStartYmd", this.minStartDate);
            }
          }
        }
      }
    },
    /**
     * AccountSearchBox 컴포넌트 찾기
     * @param {Array} children children 리스트
     */
    findSearchBox(children) {
      for (const comp of children) {
        if (comp.$vnode.componentOptions.tag == "account-search-box") {
          return comp;
        } else {
          let etc = this.findSearchBox(comp.$children);
          if (etc !== undefined) return etc;
        }
      }
    },
  },
};
</script>
